module.exports = __webpack_public_path__ + "static/img/default_ content.884045d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_ content.jpg
// module id = DyrR
// module chunks = 27